module.exports = __webpack_public_path__ + "fonts/almoni-light-aaa.e1ba15b.woff2";